'use strict';

angular.module('cloudBillingLegacyFrontend').controller('ModalCspUpdateM1AccountCtrl', function($scope, $modalInstance, AccountModel) {

  $scope.newAccount = {
    Name: '',
    TenantId: '',
    DataIntegrationId: '',
    ClientId: '',
    ClientSecret: "",
    Activation: "",
    DefaultResellerManagement: false,
    Disabled: false
  };

  $scope.updateMode = false;
  
  // edit the account model
  if (AccountModel && AccountModel.Name) {
    $scope.updateMode = true;    
    $scope.newAccount = JSON.parse(JSON.stringify(AccountModel));    
    
    if ($scope.newAccount.ClientId && $scope.newAccount.ClientId.startsWith('M1/')) {
      // split the client id and assign to the fields
      var clientIdParts = $scope.newAccount.ClientId.split('/');
      $scope.newAccount.TenantId = clientIdParts[1];
      $scope.newAccount.DataIntegrationId = clientIdParts[3];
      $scope.newAccount.ClientId = clientIdParts[2];

      if (clientIdParts.length > 4) {
        $scope.newAccount.Activation = clientIdParts[4];
      }
    }

    $scope.title = "Update Modern Platform Account";
  } else {
    $scope.title = "Register Modern Platform Account";
  }

  $scope.ok = function () {
    // patch in the clientId 
    $scope.newAccount.ClientId = 'M1/' + $scope.newAccount.TenantId + '/' + $scope.newAccount.ClientId + '/' + $scope.newAccount.DataIntegrationId;
    if ($scope.newAccount.Activation && $scope.newAccount.Activation !== '*') {
      $scope.newAccount.ClientId = $scope.newAccount.ClientId + '/' + $scope.newAccount.Activation;
    }

    $modalInstance.close({ account: $scope.newAccount, action: $scope.updateMode ? 'update' : 'create'});
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel")
  };

  $scope.removeAccount = function() {
    var ok = confirm('Do you really want to remove this account? This will remove all data from the system and you need to re-register the account later if required.');
    if (ok) { $modalInstance.close({action: 'remove'}); }
  };  
});



